import { configureStore } from "@reduxjs/toolkit";
import UserContactServices from "./services/UserContactServices";
import AuthService from "./services/AuthServices";
import globalReducer from "./reducers/globalReducers";
import AuthReducer from "./reducers/AuthReducers";
import HomeServices from "./services/HomeServices";
import CategoryService from "./services/CategoryService";
import ClientsReview from "./services/ClientsReview";
import InnerServices from "./services/InnerServices";
import AboutServices from "./services/AboutServices";
import FaqsServices from "./services/FaqsServices";
import ProductsServices from "./services/ProductsServices";
import InterestService from "./services/InterestService";
import ApplyloanServices from "./services/ApplyloanServices";
import EditDrivingService from "./services/EditDrivingService";
import SiteSettingServices from "./services/SiteSettingServices";

const Store = configureStore({
	reducer: {
		[AuthService.reducerPath]: AuthService.reducer,
		[UserContactServices.reducerPath]: UserContactServices.reducer,
		[HomeServices.reducerPath]: HomeServices.reducer,
		[CategoryService.reducerPath]: CategoryService.reducer,
		[ClientsReview.reducerPath]: ClientsReview.reducer,
		[InnerServices.reducerPath]: InnerServices.reducer,
		[AboutServices.reducerPath]: AboutServices.reducer,
		[FaqsServices.reducerPath]: FaqsServices.reducer,
		[ProductsServices.reducerPath]: ProductsServices.reducer,
		[InterestService.reducerPath]: InterestService.reducer,
		[ApplyloanServices.reducerPath]: ApplyloanServices.reducer,
		[EditDrivingService.reducerPath]: EditDrivingService.reducer,
		[SiteSettingServices.reducerPath]: SiteSettingServices.reducer,
		globalReducer: globalReducer,
		AuthReducer: AuthReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat([
			AuthService.middleware,
			UserContactServices.middleware,
			HomeServices.middleware,
			CategoryService.middleware,
			ClientsReview.middleware,
			InnerServices.middleware,
			AboutServices.middleware,
			FaqsServices.middleware,
			ProductsServices.middleware,
			InterestService.middleware,
			ApplyloanServices.middleware,
			EditDrivingService.middleware,
			SiteSettingServices.middleware,
		]),
});
export default Store;
